import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * DashboardRouter - Intelligently routes users to their appropriate dashboard
 * Admin/Staff → role-based dashboards (admin-dashboard, staff-dashboard)
 * Regular users → tier-based dashboards (user-dashboard, citizen-dashboard)
 */
const DashboardRouter = () => {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate('/login');
      return;
    }

    // Route based on userType first (admin/staff use role-based dashboards)
    switch (currentUser.userType) {
      case 'admin':
        navigate('/admin-dashboard', { replace: true });
        break;
      
      case 'staff':
        navigate('/staff-dashboard', { replace: true });
        break;
      
      case 'citizen':
        navigate('/citizen-dashboard', { replace: true });
        break;
      
      default:
        // Regular users - check if they have citizen card for tier routing
        if (currentUser.cardNumber) {
          navigate('/citizen-dashboard', { replace: true });
        } else {
          navigate('/user-dashboard', { replace: true });
        }
    }
  }, [currentUser, navigate]);

  // Return null while redirecting
  return null;
};

export default DashboardRouter;
